import UserService from '../service/User';

export const isLogin = () => {
  if (localStorage.getItem('accessToken')) {
    return true;
  } else {
    return false;
  }
};

export const userGradeType = async () => {
  const userData = await UserService.userInfo();
  return userData.data.plan_grade;
};

export const userRegion = (planRegion: string) => {
  if (!planRegion) return [];
  const regionCode = planRegion.split(',');

  const regionMap: Record<string, string> = {
    A: '전국',
    B: '수도권(서울,경기,인천)',
    C: '서울',
    D: '경기',
    E: '인천',
    F: '지방 통합(수도권 제외 전지역)',
    G: '충청권',
    H: '강원권',
    I: '경상권',
    J: '호남권',
    K: '제주도',
  };
  const regions = regionCode.map((code: string) => regionMap[code]);

  return regions;
};

export const REGION_CODE_MAP: Record<string, string[]> = {
  A: ['전국'], // 전국
  B: ['서울', '경기', '인천'], // 수도권
  C: ['서울'], // 서울
  D: ['경기'], // 경기
  E: ['인천'], // 인천
  F: [
    '부산',
    '대전',
    '대구',
    '울산',
    '세종',
    '강원',
    '충북',
    '충남',
    '경북',
    '경남',
    '광주',
    '전북',
    '전남',
    '제주',
  ], // 지방 통합
  G: ['대전', '세종', '충북', '충남'], // 충청권
  H: ['강원'], // 강원권
  I: ['부산', '대구', '울산', '경북', '경남'], // 경상권
  J: ['광주', '전북', '전남'], // 호남권
  K: ['제주'], // 제주도
};

export const isFinalMonth = (plan_end?: string | null) => {
  if (!plan_end) return false;
  const today = new Date();

  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(plan_end);
  if (!m) return false;

  const endYear = Number(m[1]);
  const endMonth = Number(m[2]); // 1~12

  const curYear = today.getFullYear();
  const curMonth = today.getMonth() + 1; // 0-index → 1~12

  if (endYear === curYear && endMonth === curMonth) return true;
  return false;
};
